import {useContext, useEffect, useMemo, useState} from 'react'
import {DataContext} from '../../context/DataContext'
import {FilterContext} from '../../context/FilterContext'
import {BarChartPorVaga} from '../Charts/BarChartPorVaga'

type Props = {
  label?: string
  itens: any[]
}

export default function ResumoMediaPrecoPorVaga({label, itens}: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {data, cacheResult, setCacheResult} = useContext(DataContext)
  const {filter} = useContext(FilterContext)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedItem, setSelectedItem] = useState(null)
  let {chartData, groups} = useMemo(() => {
    let ticketMedio = Array(9).fill([], 0, 9)
    let totalQuartos = Array(9).fill(0, 0, 9)
    let chartData = []
    let groups = []

    if (data && filter !== null) {
      // eslint-disable-next-line array-callback-return
      data.map((item) => {
        // eslint-disable-next-line array-callback-return
        item.tipologias.map((itemTipologias) => {
          if (itemTipologias.computed) {
            if (itemTipologias.bedrooms < 10) {
              if (typeof ticketMedio[itemTipologias.bedrooms] === 'undefined') {
                ticketMedio = []
              }

              if (
                typeof ticketMedio[itemTipologias.bedrooms][itemTipologias.parking] === 'undefined'
              ) {
                ticketMedio[itemTipologias.bedrooms] = Array(9).fill(0, 0, 9)
              }

              if (
                typeof totalQuartos[itemTipologias.bedrooms][itemTipologias.parking] === 'undefined'
              ) {
                totalQuartos[itemTipologias.bedrooms] = Array(9).fill(0, 0, 9)
              }

              totalQuartos[itemTipologias.bedrooms][itemTipologias.parking] =
                totalQuartos[itemTipologias.bedrooms][itemTipologias.parking] + 1
              ticketMedio[itemTipologias.bedrooms][itemTipologias.parking] +=
                itemTipologias.original_price / itemTipologias.private_area
            }
          }
        })
      })
      // eslint-disable-next-line array-callback-return
      ticketMedio.map((item, index) => {
        if (item.length > 0) {
          let count = 0
          // eslint-disable-next-line array-callback-return
          item.map((valor, indexVagas) => {
            if (valor) {
              chartData.push({
                x: '' + indexVagas, //Vagas
                y: valor / totalQuartos[index][indexVagas],
                vagas: index,
              })

              count++
            }
          })
          groups.push({title: index, cols: count})
        }
      })

      chartData = ordenarPorVagas(chartData)
    }

    return {chartData, groups}

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filter])
  function ordenarPorVagas(array) {
    return array.sort((a, b) => a.parking - b.parking)
  }
  useEffect(() => {
    cacheResult.performanceResumoMercado.mediaM2DormVaga = {
      chartData: chartData,
      tableData: [],
    }
    setCacheResult(cacheResult)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartData])
  if (!itens) {
    return <>Carregando..</>
  }

  return (
    <BarChartPorVaga
      className={'primary'}
      title={'Média do Preço/m² por Dorm-Vaga'}
      subtitle={''}
      data={chartData}
      groups={groups}
      onChange={(id: number) => {
        setSelectedItem(id)
      }}
      legenda={['Total Unidades']}
    >
      <table className='table  table-row-dashed table-row-gray-300 table-hover'>
        <thead>
          <tr className='text-dark fw-bold'>
            {/* {chartDataVSOMetragemTable && chartDataVSOMetragemTable.length > 0
              ? Object.entries(chartDataVSOMetragemTable[0]).map((item, index) => {
                  return item[0] !== 'id' ? (
                    <th key={index} className='text-center'>
                      {Dicionario.translate(item[0])}
                    </th>
                  ) : null
                })
              : null} */}
          </tr>
        </thead>
        <tbody>
          {/* {chartDataVSOMetragemTable
            ? chartDataVSOMetragemTable.map((item, index) => {
                return (
                  <tr key={index} className={item.id === selectedItem ? 'select-data-table' : ''}>
                    <td className='text-center'>{item.preco}</td>
                    <td className='text-center'>
                      {formatNumber(item.ticketMedio, 'currency_inteiro')}
                    </td>
                    <td className='text-center'>
                      {formatNumber(item.precoMedioM2, 'currency_inteiro')}
                    </td>
                    <td className='text-center'>{item.totalUnidades}</td>
                  </tr>
                )
              })
            : null} */}
        </tbody>
      </table>
    </BarChartPorVaga>
  )
}
